module.exports = __webpack_public_path__ + "static/media/sidebar-2.3ee24d51.jpg";